import { IconButton, styled, TableCell, TableRow } from '@mui/material';
import { IconAdd } from 'assets/img';
import { DayHeaderCell } from './ort-table-day-header-cell';

type AddPeriodRowProps = {
  showDayHeader: boolean;
  dayLabel: string;
  onAdd: () => void;
};

export const AddPeriodRow = ({ showDayHeader, dayLabel, onAdd }: AddPeriodRowProps) => (
  <TableRow>
    {showDayHeader && <DayHeaderCell label={dayLabel} rowSpan={1} />}
    <StyledTableCell>--:--</StyledTableCell>
    <StyledTableCell>--:--</StyledTableCell>
    <StyledTableCell>--</StyledTableCell>
    <StyledTableCell align="right">
      <IconButton size="small" color="primary" onClick={onAdd} data-testid="add-period-button">
        <IconAdd fontSize="small" />
      </IconButton>
    </StyledTableCell>
  </TableRow>
);

const StyledTableCell = styled(TableCell)({
  fontWeight: 'bold',
  width: '20%',
});
